import { render, staticRenderFns } from "./HotelNav.vue?vue&type=template&id=0b746597&scoped=true&"
import script from "./HotelNav.vue?vue&type=script&lang=js&"
export * from "./HotelNav.vue?vue&type=script&lang=js&"
import style0 from "./HotelNav.vue?vue&type=style&index=0&id=0b746597&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b746597",
  null
  
)

export default component.exports